export default __webpack_public_path__ + "static/media/AboutCoverImage.eec3e832.jpg";